import router from "@/router";
import store from "@/store";
export default {
  getMenu() {
    let navData = [
      {
        id: "1",
        name: "新闻管理",
        router: "NewsManage",
        icon: "el-icon-s-order",
        hidden: false,
        routerPath: null,
        pagePath: null,
        type: "menu",
        openType: null,
        children: [
          {
            id: "1-1",
            name: "新闻发布",
            router: "NewsPublish",
            hidden: true,
            routerPath: "NewsManage/NewsPublish",
            pagePath: "NewsManage/NewsPublish",
            type: "page",
            openType: "new",
          },
          {
            id: "1-2",
            name: "新闻列表",
            router: "NewsList",
            hidden: false,
            routerPath: "NewsManage/NewsList",
            pagePath: "NewsManage/NewsList",
            type: "page",
            openType: "current",
          },
        ],
      },
      {
        id: "2",
        name: "招标管理",
        router: "BiddingManage",
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: null,
        pagePath: null,
        type: "menu",
        openType: null,
        children: [
          {
            id: "2-1",
            name: "标书信息发布",
            router: "BiddingPublish",
            hidden: true,
            routerPath: "BiddingManage/BiddingPublish",
            pagePath: "BiddingManage/BiddingPublish",
            type: "page",
            openType: "new",
          },
          {
            id: "2-2",
            name: "招标公告",
            router: "TenderList",
            hidden: false,
            routerPath: "BiddingManage/TenderList",
            pagePath: "BiddingManage/TenderList",
            type: "page",
            openType: "current",
          },
          {
            id: "2-3",
            name: "中标公告",
            router: "WinBidList",
            hidden: false,
            routerPath: "BiddingManage/WinBidList",
            pagePath: "BiddingManage/WinBidList",
            type: "page",
            openType: "current",
          },
          {
            id: "2-4",
            name: "补充公告",
            router: "SupplyList",
            hidden: false,
            routerPath: "BiddingManage/SupplyList",
            pagePath: "BiddingManage/SupplyList",
            type: "page",
            openType: "current",
          },
        ],
      },
      {
        id: "3",
        name: "法律法规",
        router: "Laws",
        icon: "el-icon-s-finance",
        hidden: false,
        routerPath: null,
        pagePath: null,
        type: "menu",
        openType: null,
        children: [
          {
            id: "3-1",
            name: "法律法规发布",
            router: "LawsPublish",
            hidden: true,
            routerPath: "Laws/LawsPublish",
            pagePath: "Laws/LawsPublish",
            type: "page",
            openType: "new",
          },
          {
            id: "3-2",
            name: "法律法规",
            router: "LawsList",
            hidden: false,
            routerPath: "Laws/LawsList",
            pagePath: "Laws/LawsList",
            type: "page",
            openType: "current",
          },
        ],
      },
    ];
    store.commit("changeNavData", navData);
  },
  addRoute(arr) {
    for (let item of arr) {
      if (item.type == "page") {
        router.addRoute("Main", {
          path: item.routerPath,
          name: item.router,
          component: () => import("@/views/" + item.pagePath),
          meta: {
            title: item.name,
          },
        });
      }
      if (item.children && item.children.length > 0) {
        this.addRoute(item.children);
      }
    }
  },
  findNavItem(router, arr) {
    for (let item of arr) {
      if (item.router == router) {
        return item;
      } else {
        if (item.children && item.children.length > 0) {
          let result = this.findNavItem(router, item.children);
          if (result) return result;
        }
      }
    }
  },
  getDate() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
      month = "0" + month;
    }
    if (day < 10) {
      day = "0" + day;
    }
    return year + "-" + month + "-" + day;
  },
};
